import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorProviderService {
  errorConfig: any;
  errorTranslation: any;

  constructor(private configService: ConfigService, private translationService: TranslationService) { }

  getErrorInfo(errorInfo: any) {
    this.errorConfig = this.configService.getBackOfficeConfig().ERROR_MASTER_LIST;
    this.errorTranslation = this.translationService.getTranslationForPage('error_message');
    let errroStatus;
    let errorMessageInfo;
    let errorObj = {
      errorCode: '',
      errorMessage: '',
      displayMessage: ''
    }
    if (this.checkIsSdkError(errorInfo)) {
      const errorDetails = errorInfo?.message?.split('-');
      errroStatus = errorDetails[0]?.trim();
      errorMessageInfo = errorDetails[1]
    } else if (errorInfo && errorInfo.length > 0) {
      const errordetails = errorInfo[0];
      errroStatus = errordetails.status;
      errorMessageInfo = errordetails.errors;
    }
    switch (errroStatus?.toString()) {
      case '401':
      case '404':
      case '502':
      case '503':
      case '504':
      case '400006':
      case '400009':
        errorObj = this.errorConfig['sdpr'][errroStatus];
        errorObj['displayMessage'] = this.errorTranslation[this.errorConfig['sdpr'][errroStatus]['displayMessage']]
        errorObj['errorCode'] = 'SDPR - <' + errorObj.errorCode + '>'
        break;
      case '400':
      case '423':
      case '500':
        errorObj.errorCode = this.errorConfig['sdpr'][errroStatus][errorMessageInfo.name] ? 'SDPR - <' + this.errorConfig['sdpr'][errroStatus][errorMessageInfo.name]['errorCode'] + '>' : 'SDPR - <' + this.errorConfig['sdpr'][errroStatus]["errorCode"] + '>';
        errorObj.errorMessage = this.errorConfig['sdpr'][errroStatus]["errorMessage"];
        errorObj.displayMessage = this.errorConfig['sdpr'][errroStatus][errorMessageInfo.name] ? this.errorTranslation[this.errorConfig['sdpr'][errroStatus][errorMessageInfo.name]['displayMessage']] : this.errorTranslation[this.errorConfig['sdpr'][errroStatus]["displayMessage"]]
        break;
      case '403':
        errorObj.errorCode = this.errorConfig['sdpr'][errroStatus][errorMessageInfo.name] ? 'SDPR - <' + this.errorConfig['sdpr'][errroStatus][errorMessageInfo.name]['errorCode'] + '>' : 'SDPR - <' + this.errorConfig['sdpr'][errroStatus]["errorCode"] + '>';
        errorObj.errorMessage = this.errorConfig['sdpr'][errroStatus]["errorMessage"];
        errorObj.displayMessage = this.getDisplayMessageInfo(errorMessageInfo, errroStatus);
        break;
      case '403005':
      case '403025':
        errorObj = this.errorConfig['gigya'][errroStatus];
        errorObj['displayMessage'] = this.errorTranslation[this.errorConfig['gigya'][errroStatus]['displayMessage']];
        errorObj['errorCode'] = 'GIGYA - <' + errorObj.errorCode + '>'
        break;
      case '00020':
      case '00997':
        errorObj = this.errorConfig['sdk'][errroStatus];
        errorObj['displayMessage'] = this.errorTranslation[this.errorConfig['sdk'][errroStatus]['displayMessage']];
         errorObj['errorCode'] = 'SDK - <' + errorObj.errorCode + '>'
        break;
      default:
        errorObj = this.errorConfig['default'];
        errorObj['displayMessage'] = this.errorTranslation[this.errorConfig['default']['displayMessage']];
        break;
    }
    return errorObj;
  }

  private getDisplayMessageInfo(errorMessageInfo: any, errroStatus: any) {
    switch (errorMessageInfo.name) {
      case 'INVALID_PIN':
      case 'INVALID_VOICE_CODE':
      case 'INVALID_QNA':
      case 'INVALID_QNA_ATTEMPTS':
        let attemptsRemaining = errorMessageInfo.message + ' : ' + errorMessageInfo.attemptsRemaining;
        return this.errorTranslation[this.errorConfig['sdpr'][errroStatus][errorMessageInfo.name][attemptsRemaining]['displayMessage']];
    }
    return this.errorConfig['sdpr'][errroStatus][errorMessageInfo.name] ? [this.errorConfig['sdpr'][errroStatus][errorMessageInfo.name]['displayMessage']] : this.errorTranslation[this.errorConfig['sdpr'][errroStatus]["displayMessage"]];
  }

  private checkIsSdkError(errorInfo: any) {
    if (errorInfo && !Array.isArray(errorInfo)) {
      return true;
    }
    return false;
  }
}
